import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import DateRangePicker from "../Reusable/DateRangePicker";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../utils/classNames";

const RunsheetFilter = (props: any) => {
  const {
    register,
    setValue,
    getValues,
    errors,
    watch,
    clearErrors,
    isFilterVisible,
    handleFilterReset,
    reset,
  } = props;
  return (
    <div
      className={classNames(
        props?.isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 md:grid-cols-3 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxInput
            url={APIS.VEHICLE}
            queryKey={"vehicle"}
            register={register("vehicle")}
            errors={errors?.vehicle}
            name={"vehicle"}
            label={"Vehicle Number"}
            setValue={setValue}
            placeholder={"Search vehicle"}
            getValues={getValues}
            props={{ is_active: true }}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.DRIVER}
            queryKey={"driver"}
            register={register("driver")}
            errors={errors?.driver}
            name={"driver"}
            label={"Driver"}
            setValue={setValue}
            props={{ is_active: true }}
            placeholder={"Search driver"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      ) : (
        ""
      )}
      <button
        className={tw`absolute -top-5 right-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
        onClick={() => reset()}
      >
        Reset
      </button>
    </div>
  );
};

export default RunsheetFilter;
